import React from "react";
import { Badge } from "@/components/ui/badge";

const MAP = {
  // leads
  NEW: "bg-sky-50 text-sky-700 border-sky-200",
  CONTACTED: "bg-indigo-50 text-indigo-700 border-indigo-200",
  QUALIFIED: "bg-purple-50 text-purple-700 border-purple-200",
  RFQ: "bg-amber-50 text-amber-700 border-amber-200",
  QUOTATION: "bg-blue-50 text-blue-700 border-blue-200",
  NEGOTIATION: "bg-orange-50 text-orange-700 border-orange-200",
  WON: "bg-emerald-50 text-emerald-700 border-emerald-200",
  LOST: "bg-rose-50 text-rose-700 border-rose-200",
  // rfq
  "UNDER REVIEW": "bg-indigo-50 text-indigo-700 border-indigo-200",
  QUOTED: "bg-blue-50 text-blue-700 border-blue-200",
  // quotation
  DRAFT: "bg-slate-100 text-slate-600 border-slate-200",
  SENT: "bg-sky-50 text-sky-700 border-sky-200",
  VIEWED: "bg-indigo-50 text-indigo-700 border-indigo-200",
  ACCEPTED: "bg-emerald-50 text-emerald-700 border-emerald-200",
  REJECTED: "bg-rose-50 text-rose-700 border-rose-200",
  EXPIRED: "bg-slate-100 text-slate-500 border-slate-200",
  // orders
  CONFIRMED: "bg-sky-50 text-sky-700 border-sky-200",
  PROCESSING: "bg-amber-50 text-amber-700 border-amber-200",
  SHIPPED: "bg-indigo-50 text-indigo-700 border-indigo-200",
  COMPLETED: "bg-emerald-50 text-emerald-700 border-emerald-200",
  CANCELLED: "bg-rose-50 text-rose-700 border-rose-200",
  // followups / company
  Pending: "bg-amber-50 text-amber-700 border-amber-200",
  Completed: "bg-emerald-50 text-emerald-700 border-emerald-200",
  Missed: "bg-rose-50 text-rose-700 border-rose-200",
  Rescheduled: "bg-indigo-50 text-indigo-700 border-indigo-200",
  active: "bg-emerald-50 text-emerald-700 border-emerald-200",
  trial: "bg-amber-50 text-amber-700 border-amber-200",
  suspended: "bg-rose-50 text-rose-700 border-rose-200",
  // priority
  High: "bg-rose-50 text-rose-700 border-rose-200",
  Medium: "bg-amber-50 text-amber-700 border-amber-200",
  Low: "bg-slate-100 text-slate-600 border-slate-200",
};

export function StatusBadge({ value }) {
  const cls = MAP[value] || "bg-slate-100 text-slate-600 border-slate-200";
  return (
    <Badge variant="outline" className={`${cls} font-medium rounded-full px-2.5 py-0.5 text-xs capitalize`} data-testid={`status-badge-${value}`}>
      {value}
    </Badge>
  );
}
